<template>
  <section id="dashboard-ecommerce">
    <FormFilter :submit-filter="submitFilter">
      <b-col v-for="(item, index) of fieldFilter" :key="index" cols="4">
        <b-form-group :label="item.label" :label-for="item.id">
          <b-form-select :id="item.id" :value="item.model" :options="item.options" :disabled="(!$can('Filter', 'b-monitoring') &&
            !$can('Filter-PdUpd', 'b-monitoring')) || item.isDisabled" @change="item.change" />
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="PD/UKPD" label-for="pdUkpdFilter">
          <v-select id="kolok" v-model="pdUpdFilterValue" label="text" :options="dataPdUpd" :disabled="(!$can('Filter', 'b-monitoring') &&
            !$can('Filter-PdUpd', 'b-monitoring')) || isDisablePdUpd
            " @input="inputPdUpd" />
        </b-form-group>
      </b-col>
    </FormFilter>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="mb-1">
          Monitoring Inventarisasi BMD
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" class="mt-2">
            <!-- search input -->
            <div class="custom-search d-flex justify-content-between mb-1">
              <div>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="clickPrint">
                  Print
                </b-button>
              </div>
              <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Cari</label>
                  <b-form-input v-model="searchQueryDashboardSummary" placeholder="Tekan Enter" type="text"
                    class="d-inline-block" @keyup.enter="keyUpSearchDashboardSummary" />
                </div>
              </b-form-group>
            </div>
            <vue-good-table :columns="tableColumnsDashboardSummary" :rows="rowsDashboardSummary" :search-options="{
              enabled: true,
              externalQuery: searchQueryDashboardSummary,
            }" :pagination-options="{
  enabled: true,
  perPage: perPageSummary,
  jumpFirstOrLast: true,
}" :total-rows="totalRecordsDashboardSummary" :is-loading="!isShowTableSummary" mode="remote">
              <template slot="table-row" slot-scope="props">
                <!-- Column: aksi -->
                <span v-if="props.column.field === 'aksi'">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="info" class="btn-icon" size="sm"
                    @click="clickDetail(props.row)">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </span>
                <span v-else-if="props.column.field === 'persiapan'">
                  <b-badge :variant="props.row.sk_tim_upload == 'Unggah SK Tim' ? 'light-success' : 'light-secondary'"
                    class="mb-1">
                    SK Tim : {{ props.row.sk_tim_upload }}
                  </b-badge>
                  <b-badge :variant="props.row.jumlah_ruang == 0 ? 'light-secondary' : 'light-success'" class="mb-1">
                    Jumlah Ruangan : {{ props.row.jumlah_ruang }}
                  </b-badge>
                  <b-badge
                    :variant="props.row.validasi_daftar_bmd_nama == 'Sudah divalidasi Kepala' ? 'light-success' : 'light-secondary'">
                    Daftar BMD : {{ props.row.validasi_daftar_bmd_nama }}
                  </b-badge>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                    <b-form-select v-model="perPageSummary" :options="['10','25','50']" class="mx-1"
                      @input="inputPerPageSummary" />
                    <span class="text-nowrap">
                      dari {{ totalRecordsDashboardSummary }} entri
                    </span>
                  </div>
                  <div>
                    <b-pagination :value="1" :total-rows="totalRecordsDashboardSummary" :per-page="perPageSummary"
                      first-number last-number align="right" prev-class="prev-item" next-class="next-item"
                      class="mt-1 mb-0" @change="changePageSummary">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <ModalDetail v-if="isShowDetail" :is-show="isShowModal" :kolok-val="kolok" />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import { VueGoodTable } from 'vue-good-table'
import apiDashboard from '@/composables/b/dashboard'
import master from '@/composables/master'
import apiMaster from '@/composables/master/masterBRef'
import { generateYears, startYear, intThousand } from '@/libs/helper'
import FormFilter from '@/components/form/FormFilter'
import ModalDetail from '@/views/b/monitoring/components/ModalDetail'

const { showError } = require('@/libs/helper')

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')
    const isPrint = ref(false)

    const pdUpdFilter = ref($route.query['pd-upd'] || 'semua')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: 'semua' })
    const wilayahFilter = ref($route.query.wilayah || 'semua')
    const tahunFilter = ref(year)
    const kolok = ref('')

    const isShowTableSummary = ref(true)
    const isDisablePdUpd = ref(true)
    const isShowModal = ref(false)
    const isShowDetail = ref(true)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (['A', 'D', 'F'].includes(cookiesJenisAkun.value)) {
      const cookiesKolok = g.$cookies.get('kolok')
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok}::${g.$cookies.get('nalok')}`,
        value: cookiesKolok,
      }
      pdUpdFilter.value = cookiesKolok
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') { wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10) }

    let tempListYear = [{
      text: '--Pilih Salah Satu--',
      value: '',
    }]
    if (g.$cookies.get('listTahun')) {
      const listTahun = JSON.parse(g.$cookies.get('listTahun'))
      tempListYear = [...tempListYear, ...listTahun.map(item => ({ ...item, value: item.tahun_pelaksanaan, text: item.tahun_pelaksanaan }))]
      tahunFilter.value = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    } else {
      tempListYear = [...tempListYear, ...generateYears(startYear, year)]
      tahunFilter.value = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    }

    const searchQuery = ref('')
    const statusFilter = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const currentPage = ref(1)

    const perPageSummary = ref(10)
    const totalRecordsDashboardSummary = ref(0)
    const searchQueryDashboardSummary = ref('')
    const rowsDashboardSummary = ref([])
    const currentPageSummary = ref(1)

    const dataTahun = generateYears(startYear, year)
    const dataWilayah = ref([])
    const dataPdUpd = ref([{ text: '-- Semua --', value: 'semua' }])

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await apiMaster.getKolokDs(g, params)

      if (pdUpdFilter.value) {
        const index = resPdUpd.rows.findIndex(item => item.value == pdUpdFilter.value)
        if (index >= 0) {
          isDisablePdUpd.value = false
          pdUpdFilterValue.value = {
            text: resPdUpd.rows[index].text,
            value: resPdUpd.rows[index].value,
          }
        }
      }

      resPdUpd.rows.unshift({ text: '-- Semua --', value: 'semua' })
      dataPdUpd.value = resPdUpd.rows
    }

    const fieldFilter = computed(() => ([
      {
        label: 'Tahun',
        id: 'tahunFilter',
        model: tahunFilter.value,
        isDisabled: true,
        options: dataTahun,
        change: e => {
          tahunFilter.value = e
        },
      },
      {
        label: 'Wilayah',
        id: 'wilayahFilter',
        model: wilayahFilter.value,
        options: dataWilayah.value,
        change: async e => {
          wilayahFilter.value = e
          pdUpdFilterValue.value = { text: '-- Semua --', value: 'semua' }
          pdUpdFilter.value = ''

          if (e) {
            await getPdUpd()
            isDisablePdUpd.value = false
          } else {
            isDisablePdUpd.value = true
          }
        },
      },
    ]))

    const dataSummary = async () => {
      // if (pdUpdFilter.value) {
      isShowTableSummary.value = false

      const params = {
        filter_kolok: pdUpdFilter.value,
        limit: perPageSummary.value,
        start: (currentPageSummary.value - 1) * perPageSummary.value,
        filter_wilayah: wilayahFilter.value,
        cari: searchQueryDashboardSummary.value,
      }
      const dashboardSummary = await apiDashboard.getSummaryPerKolok(g, params)
      const { code, rows: list, totalRows } = dashboardSummary

      if (code == 200) {
        rowsDashboardSummary.value = list.map(item => ({
          ...item,
          totalBmd: new Intl.NumberFormat('id-ID').format(item.total_bmd),
          belumSensus: new Intl.NumberFormat('id-ID').format(item.belum_sensus),
          draft: new Intl.NumberFormat('id-ID').format(parseInt(item.draft, 10) + parseInt(item.menunggu_validasi_p3b, 10)),
          dikembalikanP3b: new Intl.NumberFormat('id-ID').format(item.dikembalikan_p3b),
          selesaiSensus: new Intl.NumberFormat('id-ID').format(item.selesai_sensus),
          selesaiSensusPersentase: `${new Intl.NumberFormat('id-ID', {
            maximumFractionDigits: 2,
          }).format((item.selesai_sensus / item.total_bmd) * 100)}%`,
          isValidasiKepala: item.status_hasil_akhir == 'disetujui-ka' ? 'Sudah' : 'Belum',
        }))
        totalRecordsDashboardSummary.value = totalRows
      } else {
        rowsDashboardSummary.value = []
        totalRecordsDashboardSummary.value = 0
      }

      isShowTableSummary.value = true
      // }
    }

    const submitFilter = () => {
      pdUpdFilter.value = (pdUpdFilter.value) ? pdUpdFilter.value : 'semua';
      const url = `?wilayah=${wilayahFilter.value}&tahun=${tahunFilter.value}&pd-upd=${pdUpdFilter.value}`
      window.history.pushState('', '', url)
      dataSummary()
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: 'semua' })

      dataWilayah.value = resWilayah
    }

    const keyUpSearchDashboardSummary = () => {
      currentPageSummary.value = 1
      dataSummary()
    }

    const inputPerPageSummary = () => {
      currentPageSummary.value = 1
      dataSummary()
    }

    const changePageSummary = page => {
      currentPageSummary.value = page
      dataSummary()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    const clickDetail = async item => {
      isShowDetail.value = true
      isShowModal.value = !isShowModal.value
      kolok.value = item.kolok
    }

    const clickPrint = async () => {
      try {
        isPrint.value = true

        window.open(
          `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna-b/analytic/monitoring?filter_kolok=${pdUpdFilter.value}&filter_wilayah=${wilayahFilter.value}&cari=${searchQueryDashboardSummary.value}`,
          '_blank',
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, 'Gagal Print Excel')
      }

      isPrint.value = false
    }

    const numThousand = value => intThousand(value)

    dataSummary()
    getWilayah()

    return {
      isPrint,
      isDisablePdUpd,
      isShowModal,
      isShowDetail,
      kolok,
      perPageSummary,
      searchQuery,
      searchQueryDashboardSummary,
      statusFilter,
      rowsDashboardSummary,
      sortBy,
      isSortDirDesc,
      totalRecordsDashboardSummary,
      currentPage,
      currentPageSummary,
      isShowTableSummary,
      pdUpdFilterValue,
      pdUpdFilter,
      wilayahFilter,
      tahunFilter,
      dataWilayah,
      dataPdUpd,
      inputPdUpd,
      submitFilter,
      keyUpSearchDashboardSummary,
      changePageSummary,
      inputPerPageSummary,
      clickDetail,
      numThousand,
      clickPrint,
      fieldFilter,
    }
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    VueGoodTable,
    BFormGroup,
    BFormSelect,
    FormFilter,
    ModalDetail,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPageOptions: [10, 100, 1000],
      tableColumnsDashboardSummary: [
        {
          label: '',
          field: 'aksi',
          width: '1%',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kolok PD',
          field: 'kolok_skpd',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nalok PD',
          field: 'nalok_skpd',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kolok',
          field: 'kolok',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nalok',
          field: 'nalok',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jml Total BMD',
          field: 'totalBmd',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Persiapan',
          field: 'persiapan',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jumlah Belum Inventarisasi',
          field: 'belumSensus',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Menunggu Validasi',
          field: 'draft',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jml Dikembalikan P3B',
          field: 'dikembalikanP3b',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jml Selesai Inventarisasi',
          field: 'selesaiSensus',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Validasi Kepala PD/UKPD/UPB',
          field: 'isValidasiKepala',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Persentase',
          field: 'persen_individu',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
